@if (visible && isAuthenticated) {
  <div class="container breadcrumb-outer">
    <ol class="breadcrumb">
      <li><a [routerLink]="homeRoute">Home</a></li>
      @for (breadcrumb of breadcrumbs; track breadcrumb) {
        <li>
          <a [routerLink]="[breadcrumb.url]">{{ breadcrumb.label }}</a>
        </li>
      }
    </ol>
  </div>
}
